enum StepType {
    Intro = "Intro",
    SelectPrompt = "SelectPrompt",
    CustomizeMessage = "CustomizeMessage",
    AskQuestion = "AskQuestion",
    AskFollowUpQuestion = "AskFollowUpQuestion",
    AskCustomQuestion = "AskCustomQuestion"
}

export default StepType;